import { LocationData } from "../../../../../models/LocationData";

/**
 * Returns only the relevant pickup fields for the location
 */
export const filterRelevantPickupFields = (
  locationData: LocationData,
): Record<string, boolean | null> => {
  const isLodging = locationData.has_lodging;
  const canModifyServiceList = locationData.can_modify_service_list;
  const canHaveFoodMenus = locationData.can_have_food_menus;

  const pickupFields = locationData.pickup_fields;
  if (!pickupFields) return {};

  const relevantPickupFields: Record<string, boolean | null> = {};

  for (const key in pickupFields) {
    // has_profile_description becomes has_profile_description_lodging if isLodging
    if (isLodging && key === "has_profile_description") {
      relevantPickupFields["has_profile_description_lodging"] =
        pickupFields[key];
    }

    // has_service_items is not included if canModifyServiceList is false
    if (!canModifyServiceList && key === "has_service_items") {
      continue;
    }

    // has_food_menus is not included if canHaveFoodMenus is false
    if (!canHaveFoodMenus && key === "has_food_menus") {
      continue;
    }

    relevantPickupFields[key] = pickupFields[key];
  }

  return relevantPickupFields;
};
